/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddParticipantResponse } from '../model/addParticipantResponse';
import { Conference } from '../model/conference';
import { ConnectConferenceResponse } from '../model/connectConferenceResponse';
import { ConnectParticipantResponse } from '../model/connectParticipantResponse';
import { DisconnectConferenceResponse } from '../model/disconnectConferenceResponse';
import { DisconnectParticipantResponse } from '../model/disconnectParticipantResponse';
import { GetParticipantStatusResponse } from '../model/getParticipantStatusResponse';
import { GetReservedConferencesResponse } from '../model/getReservedConferencesResponse';
import { Participant } from '../model/participant';
import { RemoveParticipantResponse } from '../model/removeParticipantResponse';
import { ReserveConferenceResponse } from '../model/reserveConferenceResponse';
import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ConferenceServiceInterface }                            from './conference.serviceInterface';


@Injectable()
export class ConferenceService implements ConferenceServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param conferenceId 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'body', reportProgress?: boolean): Observable<AddParticipantResponse>;
    public addParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddParticipantResponse>>;
    public addParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddParticipantResponse>>;
    public addParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conferenceId === null || conferenceId === undefined) {
            throw new Error('Required parameter conferenceId was null or undefined when calling addParticipant1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AddParticipantResponse>(`${this.basePath}/conference/${encodeURIComponent(String(conferenceId))}/add`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param payingParty 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public connectConference1(payingParty: string, organization?: string, login?: string, body?: Array<Participant>, observe?: 'body', reportProgress?: boolean): Observable<ConnectConferenceResponse>;
    public connectConference1(payingParty: string, organization?: string, login?: string, body?: Array<Participant>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConnectConferenceResponse>>;
    public connectConference1(payingParty: string, organization?: string, login?: string, body?: Array<Participant>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConnectConferenceResponse>>;
    public connectConference1(payingParty: string, organization?: string, login?: string, body?: Array<Participant>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (payingParty === null || payingParty === undefined) {
            throw new Error('Required parameter payingParty was null or undefined when calling connectConference1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConnectConferenceResponse>(`${this.basePath}/conference/${encodeURIComponent(String(payingParty))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param conferenceId 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public connectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'body', reportProgress?: boolean): Observable<ConnectParticipantResponse>;
    public connectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConnectParticipantResponse>>;
    public connectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConnectParticipantResponse>>;
    public connectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conferenceId === null || conferenceId === undefined) {
            throw new Error('Required parameter conferenceId was null or undefined when calling connectParticipant1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConnectParticipantResponse>(`${this.basePath}/conference/${encodeURIComponent(String(conferenceId))}/connect`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param conferenceId 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disconnectConference1(conferenceId: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<DisconnectConferenceResponse>;
    public disconnectConference1(conferenceId: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DisconnectConferenceResponse>>;
    public disconnectConference1(conferenceId: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DisconnectConferenceResponse>>;
    public disconnectConference1(conferenceId: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conferenceId === null || conferenceId === undefined) {
            throw new Error('Required parameter conferenceId was null or undefined when calling disconnectConference1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<DisconnectConferenceResponse>(`${this.basePath}/conference/${encodeURIComponent(String(conferenceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param conferenceId 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disconnectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'body', reportProgress?: boolean): Observable<DisconnectParticipantResponse>;
    public disconnectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DisconnectParticipantResponse>>;
    public disconnectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DisconnectParticipantResponse>>;
    public disconnectParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conferenceId === null || conferenceId === undefined) {
            throw new Error('Required parameter conferenceId was null or undefined when calling disconnectParticipant1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DisconnectParticipantResponse>(`${this.basePath}/conference/${encodeURIComponent(String(conferenceId))}/disconnect`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param conferenceId 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getParticipantStatus1(conferenceId: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetParticipantStatusResponse>;
    public getParticipantStatus1(conferenceId: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetParticipantStatusResponse>>;
    public getParticipantStatus1(conferenceId: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetParticipantStatusResponse>>;
    public getParticipantStatus1(conferenceId: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conferenceId === null || conferenceId === undefined) {
            throw new Error('Required parameter conferenceId was null or undefined when calling getParticipantStatus1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetParticipantStatusResponse>(`${this.basePath}/conference/${encodeURIComponent(String(conferenceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReservedConferences1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetReservedConferencesResponse>;
    public getReservedConferences1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReservedConferencesResponse>>;
    public getReservedConferences1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReservedConferencesResponse>>;
    public getReservedConferences1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetReservedConferencesResponse>(`${this.basePath}/conference/reservations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeConference1(id: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeConference1(id: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeConference1(id: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeConference1(id: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeConference1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/conference/reservation/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param conferenceId 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'body', reportProgress?: boolean): Observable<RemoveParticipantResponse>;
    public removeParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveParticipantResponse>>;
    public removeParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveParticipantResponse>>;
    public removeParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conferenceId === null || conferenceId === undefined) {
            throw new Error('Required parameter conferenceId was null or undefined when calling removeParticipant1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveParticipantResponse>(`${this.basePath}/conference/${encodeURIComponent(String(conferenceId))}/remove`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reserveConference1(organization?: string, login?: string, body?: Conference, observe?: 'body', reportProgress?: boolean): Observable<ReserveConferenceResponse>;
    public reserveConference1(organization?: string, login?: string, body?: Conference, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReserveConferenceResponse>>;
    public reserveConference1(organization?: string, login?: string, body?: Conference, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReserveConferenceResponse>>;
    public reserveConference1(organization?: string, login?: string, body?: Conference, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReserveConferenceResponse>(`${this.basePath}/conference/reservation`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
